module.exports = __webpack_public_path__ + "img/menu-off_02.fdd6ae13.png";